import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4736f23a")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "pb-3" }, "Property Information")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-xl-4 show-label-business" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Enter your business coverage")
], -1)
const _hoisted_4 = { class: "col-12 col-xl-2 col-lg-3 col-md-4 mb-3" }
const _hoisted_5 = { class: "col-12 col-xl-2 col-lg-3 col-md-4 mb-3" }
const _hoisted_6 = { class: "col-12 col-xl-2 col-lg-3 col-md-4 mb-3" }
const _hoisted_7 = { class: "col-12 col-xl-2 col-lg-3 col-md-4 mb-3" }
const _hoisted_8 = { class: "col-12 col-xl-4 col-lg-12 col-md-12 mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label hide-label-business" }, " Enter your business coverage ", -1)
const _hoisted_10 = { class: "nav nav-tabs" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "p-5 pt-3"
}
const _hoisted_16 = {
  key: 1,
  class: "p-5 pt-3"
}
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "place"
}, "Find your address", -1)
const _hoisted_19 = { class: "mb-2 mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "place"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Set your radius intervals:")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "pb-3" }, "Property Repair Details")
], -1)
const _hoisted_23 = { class: "col-12 col-xl-3 col-lg-6 col-md-6 mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Does this location offer repairs?", -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "provides_repairs_yes"
}, "Yes", -1)
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "provides_repairs_no"
}, "No", -1)
const _hoisted_32 = {
  key: 0,
  class: "col-12 col-xl-9 col-lg-6 col-md-6 mb-3"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "pb-3" }, "Property Sales Details")
], -1)
const _hoisted_36 = { class: "col-12 col-xl-3 col-lg-6 col-md-6 mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Does this location sell devices?", -1)
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-6" }
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "provides_sells_yes"
}, "Yes", -1)
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = { class: "form-check" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "provides_sells_no"
}, "No", -1)
const _hoisted_45 = {
  key: 1,
  class: "col-12 col-xl-9 col-lg-6 col-md-6 mb-3"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-12 col-xl-3 col-lg-6 col-md-6 mb-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Does this location sell cellular services?", -1)
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = { class: "form-check" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "provides_sell_cellular_services_yes"
}, "Yes", -1)
const _hoisted_55 = { class: "col-6" }
const _hoisted_56 = { class: "form-check" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "provides_sell_cellular_services_no"
}, "No", -1)
const _hoisted_58 = {
  key: 0,
  class: "col-12 col-xl-9 col-lg-6 col-md-6 mb-3"
}
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-12 mb-3" }
const _hoisted_61 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_62 = { class: "col-12 mb-3" }
const _hoisted_63 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_64 = { key: 2 }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-6" }
const _hoisted_67 = {
  key: 0,
  type: "submit",
  class: "btn btn-fw btn-primary"
}
const _hoisted_68 = {
  key: 1,
  type: "submit",
  class: "btn btn-fw btn-primary"
}
const _hoisted_69 = { class: "col-6" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_ZipCodeAndAssociatedCostList = _resolveComponent("ZipCodeAndAssociatedCostList")!
  const _component_GoogleMapsInput = _resolveComponent("GoogleMapsInput")!
  const _component_RadiusLimitsAndAssociatedCostList = _resolveComponent("RadiusLimitsAndAssociatedCostList")!
  const _component_RepairDeviceTypeSelector = _resolveComponent("RepairDeviceTypeSelector")!
  const _component_SellDeviceTypeSelector = _resolveComponent("SellDeviceTypeSelector")!
  const _component_CellularServiceTypeSelector = _resolveComponent("CellularServiceTypeSelector")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    "validation-schema": _ctx.validationSchema,
    autocomplete: "off",
    initialValues: _ctx.formValues,
    class: "mt-3",
    ref: "form"
  }, {
    default: _withCtx(({ errors, setFieldValue, values, isSubmitting }) => [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, {
              class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'name')]),
              name: "name",
              id: "name",
              type: "text",
              autocomplete: "newname",
              placeholder: "Name"
            }, null, 8, ["class"]),
            _createVNode(_component_ErrorMessage, {
              class: "invalid-feedback",
              name: "name"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Field, {
              name: "phone",
              modelValue: _ctx.phoneMaskedValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.phoneMaskedValue = $event))
            }, {
              default: _withCtx(({ meta: m }) => [
                _createVNode(_component_InputMask, {
                  class: _normalizeClass(["form-control", m.valid === false && _ctx.isInvalid(errors, 'phone')]),
                  modelValue: _ctx.phoneMaskedValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.phoneMaskedValue = $event)),
                  onChange: ($event: any) => (setFieldValue('phone', _ctx.phoneMaskedValue)),
                  mask: "(999) 999-9999",
                  unmask: true,
                  type: "tel",
                  autocomplete: "newphone",
                  placeholder: "Phone Number"
                }, null, 8, ["class", "modelValue", "onChange"])
              ]),
              _: 2
            }, 1032, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              class: "invalid-feedback",
              name: "phone"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'email')]),
              name: "email",
              id: "email",
              type: "text",
              autocomplete: "newemail",
              placeholder: "Email"
            }, null, 8, ["class"]),
            _createVNode(_component_ErrorMessage, {
              class: "invalid-feedback",
              name: "email"
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Field, {
              class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'website')]),
              name: "website",
              id: "website",
              type: "text",
              autocomplete: "newwebsite",
              placeholder: "Website (Optional)"
            }, null, 8, ["class"]),
            _createVNode(_component_ErrorMessage, {
              class: "invalid-feedback",
              name: "website"
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("ul", _hoisted_10, [
                _createElementVNode("li", _hoisted_11, [
                  _createElementVNode("a", {
                    class: _normalizeClass([{ active: values.byZipCodes }, "nav-link"]),
                    onClick: 
                    () => {
                      setFieldValue('byZipCodes', true) ||
                        setFieldValue('byAddressAndRadius', false) ||
                        setFieldValue('radiusAndFeeds', null) ||
                        _ctx.setCoverageByZipCodes()
                    }
                  
                  }, "By ZipCodes", 10, _hoisted_12)
                ]),
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("a", {
                    class: _normalizeClass([{ active: values.byAddressAndRadius }, "nav-link"]),
                    onClick: 
                    () => {
                      setFieldValue('byZipCodes', false) ||
                        setFieldValue('byAddressAndRadius', true) ||
                        setFieldValue('zipCodesAndFeeds', null) ||
                        _ctx.setCoverageByAddressAndRadius()
                    }
                  
                  }, "By address and radius", 10, _hoisted_14)
                ])
              ])
            ]),
            (values.byZipCodes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_ZipCodeAndAssociatedCostList, {
                    "form-errors": errors,
                    initialValues: values.zipCodesAndFeeds,
                    onOnListChanges: 
                (payload) => setFieldValue('zipCodesAndFeeds', payload)
              
                  }, null, 8, ["form-errors", "initialValues", "onOnListChanges"])
                ]))
              : _createCommentVNode("", true),
            (values.byAddressAndRadius)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      class: _normalizeClass(["form-control", _ctx.isInvalid(errors, 'place')]),
                      "model-value": _ctx.placeValue,
                      name: "place",
                      id: "place"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_GoogleMapsInput, {
                          placeholder: "Search address",
                          value: _ctx.placeValue,
                          "css-classes": `form-control ${_ctx.isInvalid(errors, 'place')}`,
                          inputType: _ctx.MapsSearchInputMode.ADDRESS,
                          onPlaceSelected: _ctx.handlePlaceInput,
                          onOnChange: _ctx.onChange
                        }, null, 8, ["value", "css-classes", "inputType", "onPlaceSelected", "onOnChange"])
                      ]),
                      _: 2
                    }, 1032, ["class", "model-value"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "invalid-feedback",
                      name: "place"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_RadiusLimitsAndAssociatedCostList, {
                      formErrors: errors,
                      initialValues: values.radiusAndFeeds,
                      onOnListChanges: _cache[2] || (_cache[2] = 
                  (payload) => _ctx.handleRadiusLimitsAndAssociatedCostInput(payload)
                )
                    }, null, 8, ["formErrors", "initialValues"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Field, {
                    class: _normalizeClass(["form-check-input", _ctx.isInvalid(errors, 'provides_repairs')]),
                    id: "provides_repairs_yes",
                    name: "provides_repairs",
                    type: "radio",
                    value: true
                  }, null, 8, ["class"]),
                  _hoisted_28,
                  _createVNode(_component_ErrorMessage, {
                    class: "invalid-feedback",
                    name: "provides_repairs"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Field, {
                    class: _normalizeClass(["form-check-input", _ctx.isInvalid(errors, 'provides_repairs')]),
                    id: "provides_repairs_no",
                    name: "provides_repairs",
                    type: "radio",
                    value: false
                  }, null, 8, ["class"]),
                  _hoisted_31
                ])
              ])
            ])
          ]),
          (values.provides_repairs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_RepairDeviceTypeSelector, {
                    values: values,
                    fieldName: `repair_devices`,
                    fieldIdBase: `repairs_apply_`,
                    errors: errors,
                    index: -1
                  }, null, 8, ["values", "errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_34,
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_Field, {
                    class: _normalizeClass(["form-check-input", _ctx.isInvalid(errors, 'provides_sells')]),
                    id: "provides_sells_yes",
                    name: "provides_sells",
                    type: "radio",
                    value: true
                  }, null, 8, ["class"]),
                  _hoisted_41,
                  _createVNode(_component_ErrorMessage, {
                    class: "invalid-feedback",
                    name: "provides_sells"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_Field, {
                    class: _normalizeClass(["form-check-input", _ctx.isInvalid(errors, 'provides_sells')]),
                    id: "provides_sells_no",
                    name: "provides_sells",
                    type: "radio",
                    value: false
                  }, null, 8, ["class"]),
                  _hoisted_44
                ])
              ])
            ])
          ]),
          (values.provides_sells)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_SellDeviceTypeSelector, {
                    values: values,
                    errors: errors,
                    fieldName: `sell_devices`,
                    fieldIdBase: `sell_devices_apply_`,
                    index: -1
                  }, null, 8, ["values", "errors"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_Field, {
                        class: _normalizeClass(["form-check-input", 
                        _ctx.isInvalid(errors, 'provides_sell_cellular_services')
                      ]),
                        id: "provides_sell_cellular_services_yes",
                        name: "provides_sell_cellular_services",
                        type: "radio",
                        value: true
                      }, null, 8, ["class"]),
                      _hoisted_54,
                      _createVNode(_component_ErrorMessage, {
                        class: "invalid-feedback",
                        name: "provides_sell_cellular_services"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_Field, {
                        class: _normalizeClass(["form-check-input", 
                        _ctx.isInvalid(errors, 'provides_sell_cellular_services')
                      ]),
                        id: "provides_sell_cellular_services_no",
                        name: "provides_sell_cellular_services",
                        type: "radio",
                        value: false
                      }, null, 8, ["class"]),
                      _hoisted_57
                    ])
                  ])
                ])
              ]),
              (values.provides_sell_cellular_services)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_CellularServiceTypeSelector, {
                        values: values,
                        errors: errors,
                        fieldName: `cellular_services`,
                        fieldIdBase: `cellular_services_apply_`,
                        index: -1
                      }, null, 8, ["values", "errors"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            isSubmitting
              ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        isSubmitting
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
          : _createCommentVNode("", true),
        (!isSubmitting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  (!_ctx.isEmpty(_ctx.initialValues))
                    ? (_openBlock(), _createElementBlock("button", _hoisted_67, " Update "))
                    : _createCommentVNode("", true),
                  (_ctx.isEmpty(_ctx.initialValues))
                    ? (_openBlock(), _createElementBlock("button", _hoisted_68, " Create "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-fw btn-outline-primary",
                    onClick: _cache[3] || (_cache[3] = () => _ctx.$emit('onCancel'))
                  }, " Cancel ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema", "initialValues"]))
}